import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import {  RootState } from '../redux/store';
import { useAiChatApiService } from 'api/providers/AppServiceProvider';
import { loadExistingMessageSuccess, setCurrentThread, setMessageFailure, setMessageSuccess, setPendingMessage } from 'features/thread-chat-slice';

export const useThreadChat = () => {
  const dispatch = useAppDispatch();
  const { 
    messages, 
    pendingMessage, 
    error, 
    currentMessageId,
    suggestions,
    suggestedQuestions,
    suggestedVisualizations,
    loading

  } = useAppSelector((state: RootState) => state.threadChat);
  
  const aiChatApiService = useAiChatApiService();

  const sendChatMessage = useCallback(
      async (messageid:string,message: string) => {
        if (!message.trim()) return;
        await dispatch(setPendingMessage({ prompt: message }));
        aiChatApiService.sendMessageQueryRequest({
          prompt: message,
          message_id: messageid ,
        }).then(
          (response: any) => {
              console.log(response)
             dispatch(setMessageSuccess(response));
          },
          (error:any) => {
            console.log(error);
            dispatch(setMessageFailure(error.message));
          }
        );
      },
      [dispatch, currentMessageId]
    );


  const startNewThreadConversation = useCallback(
    (messageid: string) => {
      dispatch(setCurrentThread(messageid));
      aiChatApiService.getThreadMessagesByMessageId(messageid).then(
        (response: any) => {
          dispatch(loadExistingMessageSuccess(response));
        },
        (error:any) => {
          console.log(error);
         dispatch(setMessageFailure(error.message));
        }
      );
    },
    [dispatch]
  );


  return {
    messages,
    pendingMessage,
    error,
    currentMessageId,
    suggestions,
    suggestedVisualizations,
    suggestedQuestions,
    loading,
    sendChatMessage,
    startNewThreadConversation
  };
};